<template>
    <div class="my-8 md:my-16 space-y-8">
        <div class="max-w-2xl mx-auto">
            <div class="text-center">
                <i class="icon-close mx-auto size-16 rounded-full flex items-center justify-center bg-red-50 text-3xl text-red-700" />
            </div>
            <div class="space-y-3 my-6 text-center">
                <h1 class="text-center text-2xl font-semibold leading-tight text-red-700">
                    {{ $t('Your reservation could not be completed.') }}
                </h1>
                <div class="text-center text-gray-600" v-html="$t('Your order number is :order_number', { number: order.orderNumber })" />
                <h2>{{ $t('The payment failed or was cancelled.') }}</h2>
            </div>
        </div>
        <div class="max-w-xl mx-auto">
            <OrderSummary v-if="order" :order="order" />

            <!-- Actions -->
            <div class="mt-8 flex flex-row gap-4 justify-center">
                <a v-if="order" :href="`/checkout/${order.id}/payment`" class="btn btn-primary btn-md">
                    {{ $t('Try again') }}
                </a>

                <a href="/" class="btn btn-secondary btn-md">
                    {{ $t('Back to home') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import OrderSummary from './_partials/OrderSummary.vue'
import { useAsyncRequest } from '@/composables/useAsyncRequest'

const props = defineProps({
    orderId: {
        type: String,
        required: true
    }
})
const order = ref(null)
const { get } = useAsyncRequest()

const response = await get(`/api/orders/${props.orderId}`)

order.value = response.order
</script>
